"use strict";

;

(function () {
  var getHeight = function getHeight(element) {
    element.style.display = 'block';
    var height = element.scrollHeight;
    element.style.display = '';
    return height;
  };

  var accordionAddHeight = function accordionAddHeight(accordion) {
    var accordionContent = accordion.querySelector('.accordion-item__inner');
    var height = getHeight(accordionContent);

    if (accordion.classList.contains('is-open')) {
      accordionContent.style.height = "".concat(height, "px");
    } else {
      accordionContent.style.height = '0px';
    }
  };

  var toggleAccordion = function toggleAccordion(accordion) {
    return function () {
      var accordionContent = accordion.querySelector('.accordion-item__inner');
      var accordionButton = accordion.querySelector('.accordion-item__label');
      var accordionTitle = accordionButton.innerText.trim();

      if (accordion.classList.contains('is-open')) {
        accordionContent.style.height = 0;
        accordion.setAttribute('aria-expanded', 'false');
        accordion.classList.remove('is-open');
        ga_track('accordion', 'click', "close - ".concat(accordionTitle));
      } else {
        var height = getHeight(accordionContent);
        ga_track('accordion', 'click', "open - ".concat(accordionTitle));
        accordion.classList.add('is-open');
        accordion.setAttribute('aria-expanded', 'true');
        accordionContent.style.height = "".concat(height, "px");
      }
    };
  };

  var openAccordion = function openAccordion(element) {
    if (element.classList.contains('accordion-item')) {
      element.classList.add('is-open');
      accordionAddHeight(element);
    }
  };

  var accordionsArray = Array.prototype.slice.call(document.querySelectorAll('.accordion-item'));

  if (accordionsArray) {
    for (var i = 0; i < accordionsArray.length; i += 1) {
      var button = accordionsArray[i].querySelector('.accordion-item__label');
      accordionAddHeight(accordionsArray[i]);
      button.addEventListener('click', toggleAccordion(accordionsArray[i]));
    }

    if (window.location.hash) {
      var hash = window.location.hash;
      var element = document.querySelector(hash);
      openAccordion(element);
    }

    var anchorList = document.querySelectorAll('a[href^="#"]');
    anchorList = [].slice.call(anchorList);
    anchorList.forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var hash = anchor.getAttribute('href');
        var element = document.querySelector(hash);
        openAccordion(element);
      });
    });
  }
})();